import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines, SectionLabel } from "./Motion";
import { ContactForm } from "./ContactForm";
import { CABINET } from "@/lib/content";

const MAP = "https://maps.google.com/maps?q=13%20Place%20John%20Rewald%2C%2013100%20Aix-en-Provence&z=16&output=embed";

const Info = ({ label, children }) => (
  <div className="border-t border-[#3D5A4C]/15 py-6">
    <p className="eyebrow text-[#5b6763]">{label}</p>
    <div className="mt-3 text-[1.02rem] leading-relaxed text-[#1C2826]">{children}</div>
  </div>
);

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-[#FAF8F5] py-28 sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <Reveal><SectionLabel index="06">Contact</SectionLabel></Reveal>
      <h2 className="font-serif-d mt-8 max-w-4xl text-4xl font-light leading-[1.08] text-[#1C2826] sm:text-5xl lg:text-6xl">
        <MaskLines lines={["Parlons de", <>votre <em className="italic text-[#3D5A4C]">situation</em>.</>]} />
      </h2>

      <div className="mt-16 grid gap-16 lg:grid-cols-12 lg:gap-12">
        <Reveal className="lg:col-span-7">
          <ContactForm />
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9">
          <a href={CABINET.rdvUrl} target="_blank" rel="noopener noreferrer" data-testid="contact-rdv-button"
            className="group mb-8 flex items-center justify-between gap-4 rounded-full bg-[#3D5A4C] py-4 pl-7 pr-5 text-[0.95rem] font-medium text-[#FAF8F5] transition-colors duration-300 hover:bg-[#2E453A]">
            Prendre rendez-vous en ligne
            <span className="grid h-8 w-8 place-items-center rounded-full bg-[#FAF8F5]/15 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
              <ArrowUpRight size={16} strokeWidth={1.5} />
            </span>
          </a>
          <Info label="Cabinet">
            <address className="not-italic" data-testid="contact-address">{CABINET.address.map((l) => <span key={l} className="block">{l}</span>)}</address>
          </Info>
          <Info label="Téléphone & e-mail">
            <a href={CABINET.phoneHref} data-testid="contact-phone-link" className="font-serif-d block text-3xl text-[#3D5A4C] link-underline w-fit">{CABINET.phone}</a>
            <a href={CABINET.mobileHref} data-testid="contact-mobile-link" className="font-serif-d mt-1 block text-3xl text-[#3D5A4C] link-underline w-fit">{CABINET.mobile}</a>
            <a href={`mailto:${CABINET.email}`} data-testid="contact-email-link" className="link-underline mt-2 inline-block">{CABINET.email}</a>
          </Info>
          <Info label="Horaires">
            <dl data-testid="contact-hours" className="space-y-2">
              {CABINET.hours.map(([d, h]) => (
                <div key={d}><dt className="text-sm text-[#5b6763]">{d}</dt><dd>{h}</dd></div>
              ))}
            </dl>
          </Info>
        </Reveal>
      </div>

      <Reveal className="mt-20">
        <div className="relative overflow-hidden border border-[#3D5A4C]/15 p-2">
          <iframe title="Plan d'accès au cabinet" src={MAP} data-testid="contact-map" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
            className="block h-[360px] w-full grayscale-[0.85] sepia-[0.2] sm:h-[440px]" />
        </div>
      </Reveal>
    </div>
  </section>
);
